import styled from 'styled-components';
export const AvatarContainer = styled.div `
  flex: 1;
  overflow: hidden;
`;
